// extracted by mini-css-extract-plugin
var _1 = "CalendarSection-moduleCalendarSection__vT2b2";
var _2 = "CalendarSection-moduleskeleton__lYPIc Skeleton-moduleSkeleton__Mlrfv";
var _3 = "CalendarSection-moduleview__gPttB CalendarView-moduleCalendarView__iGIi3";
export { _1 as "CalendarSection", _2 as "skeleton", _3 as "view" }
